import './styles.scss';
import qs from 'querystring';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { FiArrowDown } from '@react-icons/all-files/fi/FiArrowDown';
import { FiArrowUp } from '@react-icons/all-files/fi/FiArrowUp';
import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useProductSearchSelector } from '../ProductSearchProvider';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import {
  changedSortType,
  ProductSearchSortType,
  selectProductListSortType,
} from '~redux/search/product';
import { useQuery } from '~view/hooks/route';

const SORT_LABEL: Record<ProductSearchSortType, string> = {
  recommended: 'おすすめ順',
  brandRecommended: 'おすすめ順',
  newest: '新着順',
  lowestWholesaleRate: '掛け率の低い順',
  highestWholesaleRate: '掛け率の高い順',
  lowestPrice: '上代の安い順',
  highestPrice: '上代の高い順',
};

export type SortSelectProps = {
  listId: string;
  acliveKeys?: ProductSearchSortType[];
};

const ProductSearchSortDropdown: React.FC<SortSelectProps> = ({
  listId,
  acliveKeys,
}) => {
  const dispatch = useDispatch();
  const auth = useSelector(authUserSelector);
  const [isOpen, setOpen] = useState(false);
  const sortType = useProductSearchSelector(selectProductListSortType, listId);

  const sortMenu = useMemo(
    () =>
      acliveKeys?.length
        ? acliveKeys
        : auth
        ? [
            'recommended',
            'newest',
            'lowestWholesaleRate',
            'highestWholesaleRate',
            'lowestPrice',
            'highestPrice',
          ]
        : ['recommended', 'newest', 'lowestPrice', 'highestPrice'],
    [auth, acliveKeys]
  );

  const sort = useQuery().get('sort');
  const onSelectSortType = useCallback(
    (type: ProductSearchSortType) => {
      const decodedQuery = qs.decode(window.location.search.substring(1));
      const search = qs.encode({ ...decodedQuery, sort: type, page: 1 });
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}?${search}`
      );
      dispatch(changedSortType({ listId, sort: type }));
      setOpen(false);
    },
    [listId]
  );

  useEffect(() => {
    if (!sort) {
      return;
    }
    dispatch(changedSortType({ listId, sort: sort as ProductSearchSortType }));
  }, []);

  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        className="rounded-pill"
        disableElevation
        variant="contained"
        ref={buttonRef}
        onClick={() => setOpen(true)}
      >
        <span className="d-none d-md-inline">
          並び順: {SORT_LABEL[sortType]}
        </span>
        <span className="d-md-none">
          <FiArrowUp />
          <FiArrowDown />
        </span>
      </Button>
      <Menu
        open={isOpen}
        onClose={() => setOpen((prev) => !prev)}
        anchorEl={buttonRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        getContentAnchorEl={null}
        transitionDuration={100}
      >
        {sortMenu.map((key, index) => (
          <MenuItem
            key={`sort-selet-${index}`}
            onClick={() => onSelectSortType(key as ProductSearchSortType)}
          >
            {SORT_LABEL[key as ProductSearchSortType]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ProductSearchSortDropdown;
